import { useEffect, useState } from "react"
import { Outlet, Route, RouteProps, useNavigate } from "react-router-dom"
import { socket } from "../utils/utils"
import { useAppDispatch, useAppSelector } from "../store/hooks"
import { setState } from "../store/globalSlice"
import lobbyBg from "@/images/backgrounds/lobby-background.webp"

const PrivateRoute: React.FC = () => {
  const dispatch = useAppDispatch()
  const isLoggedIn = useAppSelector((state) => state.global.isLoggedIn)
  const nav = useNavigate()

  useEffect(() => {
    if (!isLoggedIn) {
      const user = JSON.parse(localStorage.getItem("user") || "{}")
      const token = user?.token
      socket.emit("verifyToken", token, (res) => {
        if (res) {
          dispatch(setState({ isLoggedIn: true }))
        } else {
          nav({ pathname: "/login" })
        }
      })
    }
  }, [isLoggedIn, dispatch, nav])
  if (!isLoggedIn) {
    return (
      <div
        data-testid="loader"
        className="w-screen h-screen flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${lobbyBg})` }}
      >
        <div className="bg-[#f5e2c3cc] px-10 py-8 rounded-2xl shadow-2xl border-2 border-[#a13a2b] flex flex-col items-center vintage-card">
          <span className="text-3xl font-extrabold text-white mb-2 drop-shadow-lg font-fourth vintage-text-shadow">
            Connecting...
          </span>
          <span className="text-white text-lg font-semibold">
            Please wait while we verify your session.
          </span>
        </div>
        <style>{`
              .vintage-text-shadow { text-shadow: 1px 2px 0 #2A1209, 0 2px 8px #4A2E19; }
              .vintage-card { 
                background: rgba(245, 226, 195, 0.1);
                backdrop-filter: blur(10px);
                border: 2px solid rgba(161, 58, 43, 0.3);
              }
            `}</style>
      </div>
    )
  }
  return <Outlet></Outlet>
}

export default PrivateRoute
